import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lans-footer',
  templateUrl: './lans-footer.component.html',
  styleUrls: ['./lans-footer.component.css']
})
export class LansFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/lans-footer/lans-footer.component.ts